import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import React, { ReactElement } from "react";
import { fontSizes, colors } from "../../theme";

interface CardWithHeaderProps {
  title: string;
  children: ReactElement;
  width?: number | string;
  headerColor?: string;
  id?: string;
  backgroundColor?: string;
  position?: string;
  fontSize?: string;
  fontWeight?: string | number;
}
const CardWithHeader: React.FC<CardWithHeaderProps> = ({
  title,
  children,
  id,
  headerColor = "#F5F3FF",
  backgroundColor = "#ffffff",
  position = "relative",
  width,
  fontSize = fontSizes.lg,
  fontWeight = "bold",
  ...rest
}) => {
  const sx: any = {
    backgroundColor: backgroundColor,
    borderRadius: "12px",
    position: position,
  };
  if (width) {
    sx["width"] = width;
  }
  return (
    <Card {...rest} id={id} sx={sx}>
      <CardHeader
        title={
          <Typography
            fontSize={fontSize}
            color={colors.stone[900]}
            variant="medium"
            align="center"
            fontWeight={fontWeight}
          >
            {title}
          </Typography>
        }
        sx={{ paddingBottom: 0, backgroundColor: { headerColor } }}
      ></CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
};

export default CardWithHeader;
